import { createFileRoute, redirect } from "@tanstack/react-router";

// /patio-covers → /pergola-covers (combined Patio, Gazebo & Pergola Covers page).
export const Route = createFileRoute("/patio-covers")({
  beforeLoad: () => {
    throw redirect({ to: "/pergola-covers", replace: true, statusCode: 301 });
  },
  component: () => null,
});
